import React from 'react'
import utils from './utils'

function getLevelLayout(gameContainerWidth, gameContainerHeight, settings, quantities, quantitiesNext, answer, timer = 60) {

    const commutative = settings.commutative
    const width = gameContainerWidth
    const height = gameContainerHeight
    let { value_1, value_2 } = quantities
    const colWidth = commutative ? width / 16 : width / 8
    const fontSize = colWidth
    const answerPosition = settings.answer_position && settings.answer_position === 'left' ? 'left' : 'right'
    let numbersLayout = null
    const valuesNext = getValues(quantitiesNext.value_1, quantitiesNext.value_2, quantitiesNext.value_3, '?', settings)
    const operation = settings.operation
    const operationSymbol = operation === 'addition' ? '+' : '-'
    let numbersStringNext = null

    if (commutative) {
        numbersLayout = (
            <g>
                {settings.answer_required !== 'value_1' || (settings.answer_required === 'value_1' && answer !== '?') ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth}
                    y={height / 2}
                    textAnchor="middle"
                >{settings.answer_required === 'value_1' ? answer : value_1}</text> :
                    utils.getOperationSign(
                        colWidth,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }

                {quantities.value_2 && !isNaN(quantities.value_2) ? utils.getOperationSign(
                    colWidth * 2.5,
                    height / 2,
                    fontSize,
                    settings.operation === 'addition' ? 'plus' : 'minus'
                ) : null}

                {settings.answer_required !== 'value_2' || (settings.answer_required === 'value_2' && answer !== '?') ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth * 4}
                    y={height / 2}
                    textAnchor="middle"
                >{settings.answer_required === 'value_2' ? answer : value_2}</text> :
                    utils.getOperationSign(
                        colWidth * 4,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }

                {utils.getOperationSign(
                    colWidth * 5.5,
                    height / 2,
                    fontSize,
                    'equal'
                )}

                {settings.answer_required !== 'answer' || (settings.answer_required === 'answer' && answer !== '?') ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth * 7}
                    y={height / 2}
                    textAnchor="middle"
                >{settings.answer_required === 'answer' ? answer : `${settings.operation === 'addition' ? +value_1 + +value_2 : +value_1 - +value_2}`}</text> :
                    utils.getOperationSign(
                        colWidth * 7,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }

                {settings.answer_required !== 'value_2' || (settings.answer_required === 'value_2' && answer !== '?') ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth * 9}
                    y={height / 2}
                    textAnchor="middle"
                >{settings.answer_required === 'value_2' ? answer : value_2}</text> :
                    utils.getOperationSign(
                        colWidth * 9,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }

                {quantities.value_2 && !isNaN(quantities.value_2) ? utils.getOperationSign(
                    colWidth * 10.5,
                    height / 2,
                    fontSize,
                    settings.operation === 'addition' ? 'plus' : 'minus'
                ) : null}

                {settings.answer_required !== 'value_1' ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth * 12}
                    y={height / 2}
                    textAnchor="middle"
                >{settings.answer_required === 'value_1' ? answer : value_1}</text> :
                    utils.getOperationSign(
                        colWidth * 12,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }

                {utils.getOperationSign(
                    colWidth * 13.5,
                    height / 2,
                    fontSize,
                    'equal'
                )}

                {settings.answer_required !== 'answer' || (settings.answer_required === 'answer' && answer !== '?') ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth * 15}
                    y={height / 2}
                    textAnchor="middle"
                >{settings.answer_required === 'answer' ? answer : `${settings.operation === 'addition' ? +value_1 + +value_2 : +value_1 - +value_2}`}</text> :
                    utils.getOperationSign(
                        colWidth * 15,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }
            </g>
        )

    } else {

        if ( answerPosition === 'left') {
            numbersLayout = (
                <g>
                    {settings.answer_required !== 'value_1' || (settings.answer_required === 'value_1' && answer !== '?') ? <text
                        className="level-text-primary"
                        fontSize={fontSize}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={colWidth * 7}
                        y={height / 2}
                        textAnchor="middle"
                    >{settings.answer_required === 'value_1' ? answer : value_1}</text> :
                        utils.getOperationSign(
                            colWidth * 7,
                            height / 2,
                            fontSize,
                            'answer'
                        )
                    }

                    {quantities.value_2 && !isNaN(quantities.value_2) ? utils.getOperationSign(
                        colWidth * 5.5,
                        height / 2,
                        fontSize,
                        settings.operation === 'addition' ? 'plus' : 'minus'
                    ) : null}

                    {settings.answer_required !== 'value_2' || (settings.answer_required === 'value_2' && answer !== '?') ? <text
                        className="level-text-primary"
                        fontSize={fontSize}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={colWidth * 4}
                        y={height / 2}
                        textAnchor="middle"
                    >{settings.answer_required === 'value_2' ? answer : value_2}</text> :
                        utils.getOperationSign(
                            colWidth * 4,
                            height / 2,
                            fontSize,
                            'answer'
                        )
                    }

                    {utils.getOperationSign(
                        colWidth * 2.5,
                        height / 2,
                        fontSize,
                        'equal'
                    )}

                    {settings.answer_required !== 'answer' || (settings.answer_required === 'answer' && answer !== '?') ? <text
                        className="level-text-primary"
                        fontSize={fontSize}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={colWidth}
                        y={height / 2}
                        textAnchor="middle"
                    >{settings.answer_required === 'answer' ? answer : `${settings.operation === 'addition' ? +value_1 + +value_2 : +value_1 - +value_2}`}</text> :
                        utils.getOperationSign(
                            colWidth,
                            height / 2,
                            fontSize,
                            'answer'
                        )
                    }
                </g>
            )
        } else {
            numbersLayout = (
                <g>
                    {settings.answer_required !== 'value_1' || (settings.answer_required === 'value_1' && answer !== '?') ? <text
                        className="level-text-primary"
                        fontSize={fontSize}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={colWidth}
                        y={height / 2}
                        textAnchor="middle"
                    >{settings.answer_required === 'value_1' ? answer : value_1}</text> :
                        utils.getOperationSign(
                            colWidth,
                            height / 2,
                            fontSize,
                            'answer'
                        )
                    }

                    {quantities.value_2 && !isNaN(quantities.value_2) ? utils.getOperationSign(
                        colWidth * 2.5,
                        height / 2,
                        fontSize,
                        settings.operation === 'addition' ? 'plus' : 'minus'
                    ) : null}

                    {settings.answer_required !== 'value_2' || (settings.answer_required === 'value_2' && answer !== '?') ? <text
                        className="level-text-primary"
                        fontSize={fontSize}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={colWidth * 4}
                        y={height / 2}
                        textAnchor="middle"
                    >{settings.answer_required === 'value_2' ? answer : value_2}</text> :
                        utils.getOperationSign(
                            colWidth * 4,
                            height / 2,
                            fontSize,
                            'answer'
                        )
                    }

                    {utils.getOperationSign(
                        colWidth * 5.5,
                        height / 2,
                        fontSize,
                        'equal'
                    )}

                    {settings.answer_required !== 'answer' || (settings.answer_required === 'answer' && answer !== '?') ? <text
                        className="level-text-primary"
                        fontSize={fontSize}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={colWidth * 7}
                        y={height / 2}
                        textAnchor="middle"
                    >{settings.answer_required === 'answer' ? answer : `${settings.operation === 'addition' ? +value_1 + +value_2 : +value_1 - +value_2}`}</text> :
                        utils.getOperationSign(
                            colWidth * 7,
                            height / 2,
                            fontSize,
                            'answer'
                        )
                    }
                </g>
            )
        }
    }

    if (commutative) {
        numbersStringNext = `${valuesNext[0]} ${operationSymbol} ${valuesNext[1]} = ${valuesNext[3]}  ${valuesNext[1]} ${operationSymbol} ${valuesNext[0]} = ${valuesNext[3]}`
    } else {
        numbersStringNext = answerPosition === 'left' ?
            `${valuesNext[3]} = ` + (valuesNext[2] ? `${valuesNext[2]} ${operationSymbol} ` : '') + `${valuesNext[1]} ${operationSymbol} ${valuesNext[0]}` :
            `${valuesNext[0]} ${operationSymbol} ${valuesNext[1]}` + (valuesNext[2] ? ` ${operationSymbol} ${valuesNext[2]} ` : '') + ` = ${valuesNext[3]}`
    }
    return (
        <svg
            height={height}
            width={width}
        >
            <text
                className="level-text-white"
                fontSize={!settings.show_tens ? width / 20 : width / 30}
                fontWeight="regular"
                dominantBaseline="middle"
                x={width / 2}
                y={fontSize}
                textAnchor="middle"
            >{'Next: ' + numbersStringNext}</text>
            {numbersLayout}
        </svg>
    )
}

function getValues(value_1, value_2, value_3, answer, settings) {
    const operation = settings.operation
    const answerRequired = settings.answer_required || 'answer'
    value_3 = value_3 && !isNaN(value_3) ? +value_3 : 0

    if (settings.show_tens) {
        if (operation === 'addition') {
            if (answerRequired === 'value_1') {
                answer = utils.isPowerOfTen(value_1) ? answer + ' tens' : answer
                return [answer, utils.getTens(value_2), utils.getTens(value_3), utils.getTens(value_1 + value_2 + value_3)]
            } else if (answerRequired === 'value_2') {
                answer = utils.isPowerOfTen(value_2) ? answer + ' tens' : answer
                return [utils.getTens(value_1), answer, utils.getTens(value_3), utils.getTens(value_1 + value_2 + value_3)]
            } else if (answerRequired === 'value_3') {
                answer = utils.isPowerOfTen(value_3) ? answer + ' tens' : answer
                return [utils.getTens(value_1), utils.getTens(value_2), answer, utils.getTens(value_1 + value_2 + value_3)]
            } else if (answerRequired === 'answer') {
                answer = utils.isPowerOfTen(value_1 + value_2 + value_3) ? answer + ' tens' : answer
                return [utils.getTens(value_1), utils.getTens(value_2), utils.getTens(value_3), answer]
            } else {
                return [utils.getTens(value_1), utils.getTens(value_2), utils.getTens(value_3), utils.getTens(value_1 + value_2 + value_3)]
            }
        } else {
            if (answerRequired === 'value_1') {
                answer = utils.isPowerOfTen(value_1) ? answer + ' tens' : answer
                return [answer, utils.getTens(value_2), utils.getTens(value_3), utils.getTens(value_1 - value_2 - value_3)]
            } else if (answerRequired === 'value_2') {
                answer = utils.isPowerOfTen(value_2) ? answer + ' tens' : answer
                return [utils.getTens(value_1), answer, utils.getTens(value_3), utils.getTens(value_1 - value_2 - value_3)]
            } else if (answerRequired === 'value_3') {
                answer = utils.isPowerOfTen(value_3) ? answer + ' tens' : answer
                return [utils.getTens(value_1), utils.getTens(value_2), answer, utils.getTens(value_1 - value_2 - value_3)]
            } else if (answerRequired === 'answer') {
                answer = utils.isPowerOfTen(value_1 - value_2 - value_3) ? answer + ' tens' : answer
                return [utils.getTens(value_1), utils.getTens(value_2), utils.getTens(value_3), answer]
            } else {
                return [utils.getTens(value_1), utils.getTens(value_2), utils.getTens(value_3), utils.getTens(value_1 - value_2 - value_3)]
            }
        }
    } else {
        if (operation === 'addition') {
            if (answerRequired === 'value_1') {
                return [answer, value_2, value_3, value_1 + value_2 + value_3]
            } else if (answerRequired === 'value_2') {
                return [value_1, answer, value_3, value_1 + value_2 + value_3]
            } else if (answerRequired === 'value_3') {
                return [value_1, value_2, answer, value_1 + value_2 + value_3]
            } else if (answerRequired === 'answer') {
                return [value_1, value_2, value_3, answer]
            } else {
                return [value_1, value_2, value_3, value_1 + value_2 + value_3]
            }
        } else {
            if (answerRequired === 'value_1') {
                return [answer, value_2, value_3, value_1 - value_2 - value_3]
            } else if (answerRequired === 'value_2') {
                return [value_1, answer, value_3, value_1 - value_2 - value_3]
            } else if (answerRequired === 'value_3') {
                return [value_1, value_2, answer, value_1 - value_2 - value_3]
            } else if (answerRequired === 'answer') {
                return [value_1, value_2, value_3, answer]
            } else {
                return [value_1, value_2, value_3, value_1 - value_2 - value_3]
            }
        }
    }
}

export default {
    getLevelLayout,
}


// WEBPACK FOOTER //
// ./src/components/game/levels/utils/challengeNumber.utils.js